import React from "react";
import { ShieldCheck, EnvelopeSimple } from "@phosphor-icons/react";
import { PRODUCTS, FOOTER_LINKS, HUB_URL, slug } from "@/lib/brand";

export default function Footer() {
  return (
    <footer className="border-t border-ink-100 bg-white" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-16">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-500 mb-6">The WorkSafeAgent products</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-px bg-ink-100 border border-ink-100" data-testid="footer-product-strip">
          {PRODUCTS.map((p) => (
            <a key={p.name} href={p.url} data-testid={`footer-product-${slug(p.name)}`}
              className={`p-5 transition-colors ${p.current ? "bg-ink-900 text-white" : "bg-white hover:bg-ink-50"}`}>
              <div className="flex items-center gap-2">
                <img src={p.icon} alt="" width={32} height={32} className="w-8 h-8 shrink-0" data-testid={`footer-product-icon-${slug(p.name)}`} />
                <div className={`font-display font-bold ${p.current ? "text-safety" : "text-ink-900"}`}>{p.name}</div>
              </div>
              <div className={`mt-1 text-xs leading-relaxed ${p.current ? "text-white/70" : "text-ink-500"}`}>{p.desc}</div>
            </a>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 bg-ink-900 flex items-center justify-center"><ShieldCheck weight="bold" className="text-white" size={16} /></div>
              <div className="font-display font-black tracking-tight text-lg" data-testid="footer-byline">SafeForm by WorkSafeAgent</div>
            </div>
            <a href={HUB_URL} data-testid="footer-hub-link" className="mt-4 block text-sm text-ink-700 hover:text-safety">
              Company hub: worksafeagent.com
            </a>
            <a href="mailto:info@wsafeai.com" data-testid="footer-email" className="mt-2 inline-flex items-center gap-2 text-sm text-ink-700 hover:text-safety">
              <EnvelopeSimple size={14} weight="bold" /> info@wsafeai.com
            </a>
          </div>
          <ul className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm" data-testid="footer-links">
            {FOOTER_LINKS.map((l) => (
              <li key={l.name}>
                <a href={l.url} data-testid={`footer-link-${slug(l.name)}`} className="text-ink-700 hover:text-safety transition-colors">{l.name}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-ink-100">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-6 text-xs text-ink-500 font-mono" data-testid="footer-legal">
          WorkSafeAgent LLC · Abilene, Texas · patent pending
        </div>
      </div>
    </footer>
  );
}
